<template>
  <div v-if="viewType === 'SETTING'">
    <div class="title-bar title-h4">대상 그룹 선택</div>
    <el-table ref="groupTable" :data="managegroupList" height="300px" @row-click="selectManagegroup" highlight-current-row>
      <el-table-column prop="label" label="그룹명" />
      <el-table-column prop="objCount" label="포함 장비 수" width="100px" />
    </el-table>
  </div>
  <div v-else-if="viewType === 'INFO'" class="wrapper">
    <el-form-item label="대상 그룹">{{ optionInfo }}</el-form-item>
  </div>
  <div v-else class="wrapper">
    <el-form-item label="대상 그룹">{{ previewOptionInfo }}</el-form-item>
  </div>
</template>

<script>
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import reportApi from '@/api/report/report';

export default {
  name: 'WWatchallGroupTable',
  props: {
    defaultValue: {
      type: Number,
    },
    defaultSetList: {
      type: Object,
      default: () => {},
    },
    viewType: {
      type: String,
      default: () => 'SETTING',
    },
    optionInfo: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      detailInfo: [],
      managegroupList: [],
      selectedManagegroupId: null,
      selectedManagegroupName: null,
      previewOptionInfo: '',
    };
  },
  methods: {
    initData(infoFlag) {
      if (!infoFlag) {
        this.detailInfo = this.defaultValue;
      }
      reportApi.getWatchallGroupList().then((response) => {
        if (response.data.success) {
          this.managegroupList = response.data.data;
          this.$nextTick(() => {
            if (this.detailInfo > 0) {
              const value = find(this.managegroupList, ['managegroupId', this.detailInfo]);
              if (!infoFlag) {
                this.$refs.groupTable.setCurrentRow(value);
                this.selectManagegroup(value);
              } else {
                this.previewOptionInfo = value.label;
              }
            }
          });
        }
      });
    },
    getData() {
      if (isNil(this.selectedManagegroupId)) {
        this.$message(msgUtil.getCustomMsgData('관리 그룹을 선택해 주십시오.'));
        return false;
      }
      return {
        WATCHALL_GROUP: this.selectedManagegroupId,
      };
    },
    getDetailData() {
      return {
        WATCHALL_GROUP: this.selectedManagegroupName,
      };
    },
    selectManagegroup(row) {
      this.selectedManagegroupId = row.managegroupId;
      this.selectedManagegroupName = row.label;
    },
    setOptionInfo(defaultValue) {
      this.previewOptionInfo = 0;
      this.detailInfo = defaultValue;
      this.initData(true);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/attr/WatchallGroupTable.vue